import { LogOut } from "lucide-react";
import Popup from "../ui/Popup";
import Button from "../ui/Button";

function LogoutModal({ setIsOpen = () => {}, isOpen, redirectUrl = "/" }) {
  // Ad and analytics cookies are not part of the session. Meta's _fbp/_fbc
  // carry the ad click that brought this customer here, and wiping them on
  // logout breaks attribution for the rest of the browser session.
  const KEEP_ON_LOGOUT = /^(_fbp|_fbc|_ga|_gid|_gcl_)/;

  function clearAllCookies() {
    const cookies = document.cookie.split(";");

    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      if (!name || KEEP_ON_LOGOUT.test(name)) continue;

      // Expire cookie for current domain
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;

      // Expire cookie for parent domain
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=.${process.env.REACT_APP_COOKIE_URL};`;
    }
  }

  const signOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    clearAllCookies();
    window.location.href = `https://${process.env.REACT_APP_SHOPIFY_STORE}.myshopify.com/account/logout`;
    setIsOpen(false);
  };

  return (
    <Popup
      open={isOpen}
      onClose={() => setIsOpen(false)}
      icon={<LogOut className="h-7 w-7" />}
      title="Sign out?"
      actions={[
        <Button key="out" onClick={signOut}>
          Sign Out
        </Button>,
        <Button key="stay" variant="secondary" onClick={() => setIsOpen(false)}>
          Stay signed in
        </Button>,
      ]}
    >
      Your books are saved. You'll need to sign in again to keep working on them.
    </Popup>
  );
}

export default LogoutModal;
